import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/merge/customer.merge.query.gql"
import type {
  CustomerMergesQuery,
  CustomerMergesQueryVariables,
} from "@/v2-backoffice-client/customer/merge/__types__/customer.merge.query"

type Options = QueryHookOptions<
  CustomerMergesQuery,
  CustomerMergesQueryVariables
>

export function useCustomerMergesQuery(options?: Options) {
  return useQuery<CustomerMergesQuery, CustomerMergesQueryVariables>(
    query,
    options,
  )
}
